module.exports = __webpack_public_path__ + "img/hello.d2d49fcc.png";